import React, { Component } from 'react';
import {Demands} from 'api';
import Promise from 'bluebird';
import {CreateConversationForm, ConversationItem} from 'components/conversations';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {ConversationContainer} from 'components/conversations';

class DemandConversationsContainer extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      hasOwnConversation: null,
      conversations: []
    }
  }

  loadConversations() {
    Promise.all([
      Demands.actions.listConversations.request({
        id: this.props.demand.id,
        filter: {
          limit: 100
        }
      }),
      Demands.actions.hasOwnConversation.request({
        id: this.props.demand.id
      })
    ]).spread((conversations, hasOwnConversation) => {
      this.setState({
        conversations: conversations.data,
        hasOwnConversation: hasOwnConversation.data
      })
    })
  }

  componentDidMount() {
    this.loadConversations();
  }

  onConversationCreate() {
    this.loadConversations();
  }

  loadConversation(conversation) {
    this.setState({
      activeConversation: conversation
    })
  }

  backToConversationList() {
    this.setState({
      activeConversation: null
    })
  }

  confirmDelete(id, reload) {
    if (confirm("Bạn có muốn xóa trao đổi này không?")) {
      // Demands.actions.delete.request({id}).then(response => {
      //   toastr.removeByType('success');
      //   toastr.success("", "Trao đổi đã được xóa");
      //   reload();
      // });
    }
  }

  render() {
    return (
      <div>
        <h1 className='user-header'>Thông tin trao đổi</h1>
        {!this.state.activeConversation &&
          <table className="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th className='col-lg-1'></th>
                <th className='col-lg-4'>Người đăng</th>
                <th className='col-lg-4'>Thông tin</th>
                <th className='col-lg-2'>Hành động</th>
              </tr>
            </thead>
            {
              this.state.conversations.map((conversation, i) => {
                return (
                  <ConversationItem {...conversation} className='' index={(i + 1)}
                    actionPanel={
                      <div>
                        <div className='row'>
                          <button className="btn btn-primary" type="button" onClick={this.loadConversation.bind(this, conversation)}>Chi tiết</button>&nbsp;
                          <button className="btn btn-danger" type="button" onClick={this.confirmDelete.bind(this, conversation.id)}>Xóa</button>
                        </div>
                      </div>
                    }
                  />
                );
              })
            }
          </table>
        }


        {
          this.state.activeConversation &&
          <div>
            [ <a href='javascript:void(0)' onClick={this.backToConversationList.bind(this)}>&lt;&lt; Quay lại</a> ]
            <ConversationContainer
              conversation={this.state.activeConversation}
            />
          </div>

        }


        {this.state.hasOwnConversation === false &&
          <CreateConversationForm
            data={{
                demandId: this.props.demand.id,
                tenderIds: [
                this.props.demand.user.id
                ]
            }}
            onConversationCreate={this.onConversationCreate.bind(this)}
          />
        }
      </div>
    );
  }
}

export default connect()(DemandConversationsContainer);



// WEBPACK FOOTER //
// ./components/demands/DemandConversationsContainer.jsx